import { createContext } from "react";
import io from "socket.io-client";

export const socket = io(`${process.env.REACT_APP_API_URL}/`, {
    auth: {
      token: JSON.parse(localStorage.getItem("user"))?.accessToken,
    },
  });

export const SocketContext = createContext();